import { Tooltip, WarningInfoIcon } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

export function MentionsAssigmentsTooltip() {
  const { t } = useTranslation();
  return (
    <Tooltip help={t('Basado en las de las franjas, no serán definitivas hasta crear el corte')}>
      <WarningInfoIcon className="text-accent-active-primary-30" />
    </Tooltip>
  );
}
